export default __webpack_public_path__ + "assets/d04e576e8cabfada694fac163a2202ee.svg";